<template>
  <div
    class="flex items-center justify-center mb-20 mx-auto rounded-full h-60 w-60 bg-sky-100"
  >
    <Headset class="h-35 w-35 text-sky-500" />
  </div>
</template>

<script>
import { Headset } from '@assets/svgs/index'

export default {
  components: {
    Headset,
  },
}
</script>
